import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import { IconButton, Switch } from "@mui/material";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import React from "react";
import { dxtToLocalServerTime, getMomentTz } from "../../../../../../services";
import { Job } from "../../../models/Job";

const moment = getMomentTz();

type Props = {
	setShowModal: (modal: "create" | "update" | "reset" | "enable" | "") => void;
	setJobSelected: (job: Job) => void;
	showContextMenu: Function;
};

export const useJobsTableData = ({
	setShowModal,
	setJobSelected,
	showContextMenu,
}: Props) => {
	const renderButtonMenu = (params: any) => {
		return (
			<IconButton
				style={{}}
				onClick={(e) => showContextMenu(e, params.data, "jobsContext")}
				size="small"
			>
				<FormatListBulletedSharpIcon
					style={{ height: "auto" }}
					fontSize="small"
					color="action"
				/>
			</IconButton>
		);
	};

	const columnDefs: ColDef[] = [
		{
			field: "sProcedure",
			headerName: "Procedures",
			type: "string",
			flex: 3,
			cellStyle: {
				justifyContent: "flex-start",
			},
		},
		{
			field: "PeriodTime",
			headerName: "Period Time",
			flex: 2,
			valueGetter: (params) =>
				moment
					.duration((params.data as Job).PeriodTime, "seconds")
					.format("h[h] m[m] s[s]"),
		},
		{
			field: "LastExecutionTime",
			headerName: "Last Execution",
			valueGetter: (params) =>
				dxtToLocalServerTime(
					(params.data as Job).LastExecutionTime,
					"MM/dd HH:mm",
				),
			flex: 2,
		},
		{
			field: "NextExecutionTime",
			headerName: "Next Execution",
			valueGetter: (params) =>
				dxtToLocalServerTime(
					(params.data as Job).NextExecutionTime,
					"MM/dd HH:mm",
				),
			flex: 2,
		},
		{
			field: "Enabled",
			headerName: "Enabled",
			minWidth: 50,
			valueFormatter: ({ value }) => (!value ? "N" : "Y"),
			flex: 1,
			cellRenderer: (params: ICellRendererParams) => (
				<Switch
					checked={!!(params.data as Job).Enabled}
					color="primary"
					size="small"
					onChange={(event, checked) => {
						setJobSelected(params.data);
						setShowModal("enable");
					}}
				/>
			),
		},
		{
			field: "-",
			headerName: "",
			cellRenderer: renderButtonMenu,
			flex: 1,
			wrapText: false,
			sortable: false,
			filter: false,
			maxWidth: 50,
		},
	];

	return { columnDefs };
};
